import angular from 'angular';
import booksMenu from '../../menu/Menu';
import findInvoiceTemplate from './templates/FindInvoice.template.html';

export default angular
  .module('invoices', [
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav',
    'ui.grid.selection',
    booksMenu
  ])
  .service('FindInvoiceDialog', FindInvoiceDialogService)
  .controller('invoiceController', invoiceController).name;

/* @ngInject */ function FindInvoiceDialogService($uibModal, uiGridConstants) {
  /** Instance Reference. */
  var mSelf = this;

  /*-----------------*/
  /* Persistent Data */
  /*-----------------*/
  /** Found Invoices. */
  mSelf.foundInvoices = [];

  /** Saved Filters. */
  var mSavedFilters;

  /*-----------------------------------------*/
  /* template to add ng-dblClick to each row */
  /*-----------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.viewInvoice(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /** Dialog Controller. */
  var FindInvoicesController = function (
    $q,
    $scope,
    Alert,
    Tools,
    SERVER,
    BooksSvc,
    BusyScreen
  ) {
    /* Generic data object. */
    $scope.data = {};

    /*---------------*/
    /* Dataproviders */
    /*---------------*/
    $scope.statusTypes = [
      { value: 'A', display: 'ANY' },
      { value: 'P', display: 'PAID' },
      { value: 'U', display: 'UNPAID' }
    ];

    /*------------------*/
    /* Find Grid Config */
    /*------------------*/
    $scope.findGridOptions = {
      enableColumnMenus: false,
      enableSorting: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      enableRowHeaderSelection: false,
      enableFullRowSelection: true,
      multiSelect: false,
      onRegisterApi: function (gridApi) {
        $scope.findGridOptions.api = gridApi;
      },
      rowTemplate: dblClickTemplate,
      columnDefs: [
        { field: 'status', displayName: 'Status', maxWidth: 85 },
        { field: 'number', displayName: 'Invoice Number', maxWidth: 130 },
        {
          field: 'entryDate',
          displayName: 'Invoice Date',
          maxWidth: 120,
          cellFilter: "date: 'MM/dd/yyyy'",
          type: 'date',
          filterCellFiltered: true
        },
        { field: 'vendorName', displayName: 'Vendor' },
        { field: 'memo', displayName: 'Title' },
        {
          field: 'amount',
          displayName: 'Total',
          maxWidth: 100,
          cellFilter: 'currency',
          type: 'number'
        }
      ],
      data: mSelf.foundInvoices
    };

    /*****************************************************************************
     * clear */
    /**
     * Reset the filters and remove any currently found invoices
     *****************************************************************************/
    $scope.clear = function () {
      $scope.findGridOptions.data = mSelf.foundInvoices = [];
      newFilters();
      $scope.clearStartDate();
      $scope.data.vendor = null;
    };

    /*****************************************************************************
     * clearStartDate */
    /**
     * Reset the start date filter.
     *****************************************************************************/
    $scope.clearStartDate = function clearStartDate() {
      $scope.filters.startDate = null;
    };

    /***************************************************************************
     * getVendors */
    /**
     * Returns a list of vendors that match the given text.
     *
     * @param   text   Current input text
     * @return         Array of sorted corresponding matching entities
     ***************************************************************************/
    $scope.getVendors = function (text) {
      /*---------------------------------------*/
      /* No input passed, return empty promise */
      /*---------------------------------------*/
      if (!text) return $q.resolve();

      var defer = $q.defer();
      BooksSvc.findAddressEntities(
        text,
        SERVER.BooksDBConstants.ET_VENDOR.toString(),
        true
      ).then(function (resp) {
        var entities = resp.data.sort(function (a, b) {
          return a.entity.fullName
            .toLowerCase()
            .localeCompare(b.entity.fullName.toLowerCase());
        });
        defer.resolve(entities);
      });
      return defer.promise;
    };

    /*****************************************************************************
     * invoiceSelected */
    /**
     * Returns an indication that an invoice has been selected.
     *****************************************************************************/
    $scope.invoiceSelected = function () {
      return $scope.findGridOptions.api.selection.getSelectedCount() > 0;
    };

    /*****************************************************************************
     * newFilters */
    /**
     * Reset the invoice filters and clear any saved filters.
     *****************************************************************************/
    function newFilters() {
      $scope.filters = {
        number: null,
        vendorID: null,
        amount: NaN,
        startDate: Tools.lastFiscalYearStart(
          SERVER.BooksOrgInfo.fyMonth,
          SERVER.BooksOrgInfo.fyDay
        ),
        endDate: null
      };
      mSavedFilters = null;
    }

    /*****************************************************************************
     * search */
    /**
     * Attempts to find invoices corresponding to the current filters.
     *****************************************************************************/
    $scope.search = function () {
      BusyScreen.setBusy(true);
      BooksSvc.findBills($scope.filters)
        .then(function (resp) {
          /* set status to "UNPAID" for unpaid invoice items  */
          angular.forEach(resp.data, function (i) {
            !i.isPaid ? (i.status = 'UNPAID') : i.status;
          });

          $scope.findGridOptions.data = mSelf.foundInvoices = resp.data;

          if (mSelf.foundInvoices.length == 0)
            Alert.info('No invoices were found', 'No Invoices Found');
          else if (mSelf.foundInvoices.length == 1)
            $scope.viewInvoice(mSelf.foundInvoices[0]);
        })
        .catch(function (error) {
          Alert.error(
            error.parsedResponse?.message() ||
              'Failed to pull up invoices. Please try again.',
            'Find Invoices Error'
          );
        })
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    };

    /*****************************************************************************
     * vendorLabelFunction */
    /**
     * For the provided AddressEntityListItem a string is return comprising of the
     * vendor name and the address if available.
     *
     * @param   v  Vendor AddressEntityListItem object
     * @return     Display string
     *****************************************************************************/
    $scope.vendorLabelFunction = function (v) {
      if (angular.isObject(v))
        return (
          (v.entity && v.entity.name ? v.entity.name : '') +
          ' ' +
          (v.address &&
          v.address.address &&
          v.address.city &&
          v.address.state &&
          v.address.zip
            ? '(' +
              v.address.address +
              ', ' +
              v.address.city +
              ', ' +
              v.address.state +
              ' ' +
              v.address.zip +
              ')'
            : '')
        );

      return '';
    };

    /*****************************************************************************
     * viewInvoice */
    /**
     * Resolve promise with passed invoice object or the selected invoice.
     *****************************************************************************/
    $scope.viewInvoice = function (invoice) {
      if (!invoice)
        invoice = $scope.findGridOptions.api.selection.getSelectedRows()[0];

      $scope.$close(invoice);
    };

    /*-------------------------------------------*/
    /* Watch vendor property to set filter value */
    /*-------------------------------------------*/
    $scope.$watch('data.vendor', function (addressEntity) {
      $scope.filters.vendorID = angular.isObject(addressEntity)
        ? addressEntity.entity.id
        : null;
    });

    if (mSavedFilters) $scope.filters = mSavedFilters;
    else newFilters();
  };

  /*****************************************************************************
   * reset */
  /**
   * Clear the saved filters and remove any found invoices.
   *****************************************************************************/
  this.reset = function () {
    mSavedFilters = null;
    mSelf.foundInvoices = [];
  };

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog to provide a means to search for invoices.
   *
   * @return         Promise to listen on
   *****************************************************************************/
  this.show = function () {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: FindInvoicesController,
      size: 'lg',
      template: findInvoiceTemplate
    }).result;
  };
}

/*******************************************************************************
 * Controller: invoiceController
 *
 * Main controller for the Invoices app
 *******************************************************************************/
/* @ngInject */ function invoiceController(
  $scope,
  $appFlags,
  $q,
  $timeout,
  Alert,
  BooksSvc,
  BusyScreen,
  FindInvoiceDialog,
  InvoiceService,
  Tools,
  Session
) {
  /*------------------------------------------*/
  /* Invoices can only create vendors so that */
  /* is the only restriction we check for.    */
  /*------------------------------------------*/
  $scope.restrictVendors = $appFlags.restrictVendors;

  /*------------*/
  /* Selections */
  /*------------*/
  /** Current Invoice Index. */ var mCurrentIdx = -1;
  /** Current Invoice ID.    */ var mInvoiceID;

  /** Current entity object. */ var mSavedEntity;

  /** UI Flags. */
  var mUI_Flags = {};
  Object.defineProperty(mUI_Flags, 'isPaid', {
    get: function () {
      return (
        !mUI_Flags.isNew &&
        (!!$scope.invoice.isPaid || $scope.amountRemaining() <= 0)
      );
    }
  });

  /** Working Invoice. */ $scope.invoice = {};
  /** Validator */ $scope.valGroup = {};

  /** Invoice Watcher deregistration function. */
  var mInvoiceWatcher = null;

  /***************************************************************************
   * allowStatusChange */
  /**
   * Returns an indication to show/hide the Change Status button.
   *
   * @return  Boolean indication
   ***************************************************************************/
  $scope.allowStatusChange = function () {
    return !mUI_Flags.isNew;
  };

  /***************************************************************************
   * amountRemaining */
  /**
   * Returns the total amount left to be paid for all items on the current
   * invoice.
   *
   * @return  Balance left on the invoice
   ***************************************************************************/
  $scope.amountRemaining = function () {
    var total = 0;
    angular.forEach($scope.invoice.items, function (item) {
      total += item.amountOwed;
    });
    return total || 0;
  };

  /***************************************************************************
   * clearInvoice */
  /**
   * Verifies the current invoice can be cleared from the UI before calling the
   * <b>method</b>. If the current invoice info has been modified, the user must
   * confirm canceling the changes before the <i>method</i> is called. If there
   * are no changes, <i>method<i> is called directly. If the user declines to
   * confirm clearing a modified invoice, focus is set on <i>comp</i>.
   *
   * @param  domElement   Component to focus if user declines.
   * @param  method       Method to call if invoice can be cleared.
   * @private
   ***************************************************************************/
  var clearInvoice = function (domElement, method) {
    $scope.valGroup.reset();

    if ($scope.invoice != null && $scope.invoice.modified) {
      var title = mUI_Flags.isNew ? 'Cancel New Invoice' : 'Cancel Changes';
      var msg = mUI_Flags.isNew
        ? 'Are you sure you want to cancel this Invoice?'
        : 'You have made changes to this invoice.\nAre you sure you want to cancel these changes?';
      Alert.confirm(msg, title).then(method, function () {
        if (domElement) domElement.focus();
      });
    } else method();
  };

  /***************************************************************************
   * changeStatus */
  /**
   * Displays a dialog prompting the user to change the payment status of an
   * invoice.
   ***************************************************************************/
  var changeStatus = function () {
    /***
     * Instead of hiding the button we allow them to hit the button so we can give them more information, about
     * the reason why they can not change the status.
     * **/
    if ($scope.amountRemaining() <= 0) {
      Alert.error(
        `
        This invoice has been paid off by one or more checks so its status can not changed.
        If you want to change the status you will need to void or drop the attached check(s).
      `,
        'Invalid Invoice Status Change'
      );
      return;
    }

    var title = 'Update Invoice Status';
    var msg =
      'Would you like to change the status of this invoice to ' +
      (mUI_Flags.isPaid ? 'UNPAID' : 'PAID') +
      ' ?';

    Alert.clear();

    Alert.confirm(msg, title).then(function () {
      BooksSvc.updateBillStatus($scope.invoice.id, !mUI_Flags.isPaid).then(
        function (resp) {
          $scope.invoice.isPaid = !mUI_Flags.isPaid;
          startNewInvoice();
          Alert.info('Status Updated');
        }
      );
    });
  };

  /***************************************************************************
   * findInvoice */
  /**
   * Shows the FindInvoiceDialog. When the promise resolves, the passed invoice
   * will be loaded and the current index is updated if multiple invoices are
   * available.
   ***************************************************************************/
  var findInvoice = function () {
    FindInvoiceDialog.show().then(function (invoice) {
      mCurrentIdx = invoicesFound()
        ? FindInvoiceDialog.foundInvoices.indexOf(invoice)
        : -1;

      clearInvoice(null, function () {
        getInvoice(invoice.id);
      });
    });
  };

  /***************************************************************************
   * getInvoice */
  /**
   * Reads an invoice from the database. Gets the current/next/previous invoice
   * from the server for the current invoice ID or traverses the list of invoices
   * from the Find results list. Loads the new invoice into the UI.
   *
   * @param  id   Current invoice ID.
   * @param  dir  Direction indicator, null=current, true=next, false=previous.
   * @private
   ***************************************************************************/
  function getInvoice(id, dir) {
    $scope.valGroup.reset();

    var endOfList = function () {
      Alert.clear();
      Alert.info('There are no more invoices', 'No More Invoices');
    };

    /*---------------------------------------------------------*/
    /* If invoices have been collected from the search, update */
    /* the index based on the direction and get the invoice ID */
    /* from the new item in the list and clear the direction.  */
    /*---------------------------------------------------------*/
    if (invoicesFound()) {
      var idx = mCurrentIdx + (dir == null ? 0 : Boolean(dir) ? 1 : -1);

      if (idx < 0 || idx >= FindInvoiceDialog.foundInvoices.length) {
        endOfList();
        return;
      }

      mCurrentIdx = idx;
      id = FindInvoiceDialog.foundInvoices[mCurrentIdx].id;
      dir = null;
    }

    /*--------------------------------------------*/
    /* Load the invoice for the ID and direction. */
    /*--------------------------------------------*/
    BusyScreen.setBusy(true);
    BooksSvc.getBill(id, dir).then(function (resp) {
      /*-------------------------------*/
      /* Load the invoice into the UI. */
      /*-------------------------------*/
      if (resp.data != null) {
        /*--------------------------------------------*/
        /* Get the matching entity with the vendor ID */
        /*--------------------------------------------*/
        BooksSvc.getEntity(resp.data.vendorID).then(function (r) {
          /*------------------------------------------------------*/
          /* Build the vendor object like an addressEntityItem,   */
          /* add to invoice object and load the invoice into UI. */
          /*------------------------------------------------------*/
          var vendor = {
            address: r.data.addressInfo,
            entity: {
              active: r.data.active,
              fullName: r.data.name,
              name: r.data.name,
              id: r.data.id
            }
          };
          resp.data.vendor = vendor;
          loadInvoice(resp.data);
          BusyScreen.setBusy(false);
        });
      } else {
        /*-------------------------------------------------------------*/
        /* No invoice was found. Start a new invoice if "next" and not */
        /* traversing find results. Else, show end of list message.    */
        /*-------------------------------------------------------------*/
        if (dir && !invoicesFound()) startNewInvoice();
        else {
          BusyScreen.setBusy(false);
          endOfList();
        }
      }
    });
  }

  /***************************************************************************
   * handleButton */
  /**
   * Generic button handler. Ensures the entity maker is not currently active
   * before continuing.
   *
   * @param  event
   ***************************************************************************/
  $scope.handleButton = function (event) {
    $scope.valGroup.reset();

    //    if (mEntityMakerActive) return;

    switch (event.target.id) {
      case 'btnCancel':
        clearInvoice(event.target, startNewInvoice);
        break;
      case 'btnChange':
        changeStatus();
        break;
      case 'btnDrop':
        handleDrop();
        break;
      case 'btnPrevious':
        clearInvoice(event.target, function () {
          getInvoice(mInvoiceID, false);
        });
        break;
      case 'btnNext':
        clearInvoice(event.target, function () {
          getInvoice(mInvoiceID, true);
        });
        break;
      case 'btnFind':
        findInvoice();
        break;
      case 'btnSave':
        saveInvoice();
        break;
      case 'btnPrint':
        print();
        break;
    }
  };

  /***************************************************************************
   * handleDrop */
  /**
   * Handles the dropping of the current invoice.
   ***************************************************************************/
  function handleDrop() {
    Alert.clear();

    Alert.confirm(
      'Are you sure you wish to drop this invoice?',
      'Confirm Drop'
    ).then(function () {
      BusyScreen.setBusy(true);
      BooksSvc.dropBill(mInvoiceID).then(function (resp) {
        BusyScreen.setBusy(false);
        startNewInvoice();
        Alert.info('The invoice has been dropped.');
      });
    });
  }

  /***************************************************************************
   * invoicesFound */
  /**
   * Returns an indication that there are multiple invoices found.
   *
   * @return boolean indication
   ***************************************************************************/
  function invoicesFound() {
    return FindInvoiceDialog.foundInvoices.length > 1;
  }

  /** New Invoice indicator. */
  $scope.isNew = function () {
    return mUI_Flags.isNew;
  };

  /** Is Paid indicator. */
  $scope.isPaid = function () {
    return mUI_Flags.isPaid;
  };

  /** Is Referenced indicator. */
  $scope.isReferenced = function () {
    return mUI_Flags.isReferenced;
  };

  /***************************************************************************
   * loadInvoice */
  /**
   * Load the provided invoice into the scope, set the approriate grid data
   * lists and reset alerts, validators and the modified flag.
   *
   * @param invoice  Invoice object to load
   ***************************************************************************/
  function loadInvoice(invoice) {
    /*----------------------------*/
    /* Clear the current watcher. */
    /*----------------------------*/
    if (mInvoiceWatcher) {
      mInvoiceWatcher();
      mInvoiceWatcher = null;
    }

    /*---------------------------------------*/
    /* Clear any alerts and stop the watcher */
    /*---------------------------------------*/
    Alert.clear();

    /* Reset Validators */
    //$scope.valGroup.reset();

    $scope.invoice = invoice;

    mInvoiceID = invoice.id || 0;

    /*-----------*/
    /* Set flags */
    /*-----------*/
    mUI_Flags.isNew = !invoice.id;
    mUI_Flags.isReferenced = !!invoice.isReferenced;

    /*----------------------------------------*/
    /* Map accounts and corresponding amounts */
    /*----------------------------------------*/
    InvoiceService.saveAccountsMap($scope.invoice.items);

    /*---------------------------------------------------*/
    /* Add the modified property as un-enumerable so the */
    /* watch will ignore it in its invoice for equality  */
    /*---------------------------------------------------*/
    Object.defineProperty($scope.invoice, 'modified', {
      enumerable: false,
      writable: true,
      value: false
    });

    /*---------------------------------------------------*/
    /* Start watching for changes, only setting the flag */
    /* when the previous value has been established.     */
    /*---------------------------------------------------*/
    mInvoiceWatcher = $scope.$watch(
      'invoice',
      function () {
        setModified(true);
      },
      true
    );

    /*---------------------------------------------------------*/
    /* Clear the modified property after the next digest       */
    /* cycle as it was set during the initialization of watch. */
    /*---------------------------------------------------------*/
    $timeout(setModified);
  }

  /***************************************************************************
   * print */
  /**
   * Print the invoice.
   *
   * @param skipCheck indication to skip modified warning
   ***************************************************************************/
  function print(skipCheck) {
    var doPrint = function () {
      window.open(
        Session.getSessionURL(
          '/PrintInvoicePDF.aspx?bID={0}'.format($scope.invoice.id)
        ),
        '_blank'
      );
    };

    /*-----------------------------------------------------*/
    /* Check for modifications to invoice before printing. */
    /*-----------------------------------------------------*/
    if (!skipCheck && $scope.invoice.modified) {
      Alert.confirm(
        'There have been changes to this invoice. Would you like to print the unmodified version?',
        'Modified Invoice'
      ).then(doPrint);
    } else doPrint();
  }

  /*****************************************************************************
   * saveInvoice */
  /**
   * Save the invoice.
   *****************************************************************************/
  function saveInvoice() {
    /*---------------------------------------------------*/
    /* Clear any previous alerts and reset the validator */
    /*---------------------------------------------------*/
    Alert.clear();
    $scope.valGroup.reset();

    /*------------------------------*/
    /* An bill needs to have items. */
    /*------------------------------*/
    if (!InvoiceService.checkItems($scope.invoice.items)) return;

    /*----------------------------------------------------------*/
    /* Abort save if any product items are missing account info */
    /*----------------------------------------------------------*/
    if (!InvoiceService.checkItemsAccount($scope.invoice.items)) return;

    /*--------------------------------*/
    /* Abort save if validation fails */
    /*--------------------------------*/
    if (!$scope.valGroup.validate()) return;

    /*-----------------------*/
    /* Check invoice amount. */
    /*-----------------------*/
    if (InvoiceService.getItemsTotal($scope.invoice.items) <= 0) {
      Alert.error('Invalid invoice amount.', 'Save Error');
      return;
    }

    /*------------------------------------*/
    /* Alert user to any overdrawn items. */
    /*------------------------------------*/
    InvoiceService.checkForOverdrawnAccounts($scope.invoice.items).then(
      function () {
        /*---------------------------------------*/
        /* Proceed with the save. Make a copy of */
        /* the bill for sending to the service.  */
        /*---------------------------------------*/
        var bill = {};
        bill.id = $scope.invoice.id;
        bill.vendorID = $scope.invoice.vendorID;
        bill.number = $scope.invoice.number;
        bill.entryDate = $scope.invoice.entryDate;
        bill.memo = $scope.invoice.memo;
        bill.items = $scope.invoice.items;
        bill.isPaid = $scope.invoice.isPaid;

        /*-----------------------*/
        /* Convert to billItems. */
        /*-----------------------*/
        angular.forEach(bill.items, function (item) {
          if (item.hasOwnProperty('inventoryProductID')) {
            item.inventoryID = item.inventoryProductID;
            delete item.inventoryProductID;
          }
        });

        /*-------------------------------------------------------*/
        /* Final sanity check. For some reason, some bills       */
        /* without a vendor ID and items are passing validation, */
        /* being sent to the server and generating errors.       */
        /*-------------------------------------------------------*/
        if (
          !bill.vendorID ||
          Tools.isEmpty(bill.memo) ||
          Tools.isEmpty(bill.number) ||
          (angular.isArray(bill.items) && bill.items.length < 1)
        ) {
          Alert.error('Invalid invoice.', 'Save Error');
          return;
        }

        /*---------------------------*/
        /* Call server to save bill. */
        /*---------------------------*/
        BusyScreen.setBusy(true);
        BooksSvc.saveBill(bill).then(
          function (resp) {
            BusyScreen.setBusy(false);
            $scope.invoice.id = Number(resp.data);

            InvoiceService.handleClosePOs(
              $scope.invoice.items,
              $scope.invoice.entryDate
            ).then(function () {
              Alert.confirm(
                'Would you like to Print the Invoice?',
                'Invoice Saved!'
              )
                .then(function (result) {
                  print(true);
                })
                .finally(function () {
                  startNewInvoice();
                });
            });
            /*--------------------------------------*/
            /* Service call rejected. Display error */
            /* to the user and disable BusyScreen.  */
            /*--------------------------------------*/
          },
          function (resp) {
            Alert.error(resp.parsedResponse.message(), 'Save Error');
            BusyScreen.setBusy(false);
          }
        );
        /* The getOverdrawnItems dialog was rejected, return to application. */
      },
      function () {}
    );
  }

  /*****************************************************************************
   * setModified */
  /**
   * Set the modified property on the $scope.invoice. If mInvoiceWatcher has
   * not been instantiated, then there is no watching being done, so the
   * modified  property will not be updated.
   *
   * @param modified  Boolean indication that the check has been modified.
   *****************************************************************************/
  function setModified(modified) {
    if (!mInvoiceWatcher) return;

    $scope.invoice.modified = !!modified;
  }

  /*****************************************************************************
   * startNewInvoice */
  /**
   * Loads a new invoice object to manage. If reloadList is true, the list data
   * will be loaded prior to the invoice.
   *
   * @param   reloadList  Boolean indicating if the list of vendors should be
   *                      reloaded.
   *****************************************************************************/
  function startNewInvoice(reloadList) {
    FindInvoiceDialog.reset();
    loadInvoice({ vendorID: NaN, entryDate: new Date(), items: [] });

    BusyScreen.setBusy(false);

    /*--------------------------------------*/
    /* Scroll to the top of the page and    */
    /* set focus on the vendor input field. */
    /*--------------------------------------*/
    $timeout(function () {
      document.querySelector('lazy-typeahead[ng-model=vendor]').focus();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);
  }

  /*---------------------*/
  /* Initialize the app. */
  /*---------------------*/
  startNewInvoice();
}
